export default function PRReportPackageGeneratedPackageController(
  $rootScope,
  ssDialogService,
  alerts,
  confirmDialog,
  reportsDataService,
  loaderService,
) {
  const vm = this;

  vm.canRetryExecution = vm.reportPackageGeneratedPackageItem.generationStatus === 3;
  vm.canDownloadItemPackage = vm.reportPackageGeneratedPackageItem.generationStatus === 4;

  vm.handleRemoveExecution = _handleRemoveExecution;
  vm.handleRetrtExecution = _handleRetryExecution;
  vm.handleDownloadPackage = _handleDownloadPackage;

  vm.handleConfirmDelete = _handleConfirmDelete;
  vm.handleCancelDelete = _handleCancelDelete;

  /** ********************************************
   * Event Handlers
   */

  
  function _handleRetryExecution($event) {
    /*
    loaderService.showViewLoader = true;
    return reportsDataService.resetGeneratedPackageExecution(vm.reportPackageGeneratedPackageItem.reportPackageGenerationQueueId).then(() => {
      alerts.success('The Generated Package has been successfully rescheduled.');
      $rootScope.$broadcast('reports.generatedPackageDeleted', {
        reportPackageId: vm.reportPackageGeneratedPackageItem.reportPackageId,
      });
      _closeDeleteDialog();
    })
    .catch(() => {
      alerts.error('An error occurred while deleting the Generated Package.');
    })
    .finally(() => {
      loaderService.showViewLoader = false;
    });
    */
  }

  function _handleRemoveExecution($event) {
    ssDialogService.dialogs.reports.deleteReportPackageExcecutionConfirmDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Remove Generated Package?',
        message: `Are you sure you want to remove the Package that was generated on "${vm.reportPackageGeneratedPackageItem.generatedDateString}"?`,
        handleYesClick: _handleConfirmDelete,
        handleNoClick: _handleCancelDelete,
      }),
    );
    return ssDialogService.show(ssDialogService.dialogs.reports.deleteReportPackageExcecutionConfirmDialog);
  }

  function _handleConfirmDelete() {
    loaderService.showViewLoader = true;
    return reportsDataService
      .deleteGeneratedPackageExecution(vm.reportPackageGeneratedPackageItem.reportPackageGenerationQueueId)
      .then(() => {
        alerts.success('The Generated Package has been successfully removed.');
        $rootScope.$broadcast('reports.generatedPackageDeleted', {
          reportPackageId: vm.reportPackageGeneratedPackageItem.reportPackageId,
        });
        _closeDeleteDialog();
      })
      .catch(() => {
        alerts.error('An error occurred while deleting the Generated Package.');
      })
      .finally(() => {
        loaderService.showViewLoader = false;
      });
  }

  function _handleDownloadPackage() {
    alerts.success('The Download of the Generated Package has been requested.The download will start momentarily.');
    reportsDataService.downloadGeneratedPackage(vm.reportPackageGeneratedPackageItem.reportPackageGenerationQueueId).then(packageResponse => {
      reportsDataService.download(packageResponse);
    });
  }

  function _handleCancelDelete() {
    _closeDeleteDialog();
  }

  /** ********************************************
   * Private Functions
   */

  function _closeDeleteDialog() {
    ssDialogService.hide(ssDialogService.dialogs.reports.deleteReportPackageGeneratedReportConfirmDialog);
  }
}

PRReportPackageGeneratedPackageController.$inject = [
  '$rootScope',
  'ssDialogService',
  'alerts',
  'confirmDialog',
  'reportsDataService',
  'loaderService',
];
